"use client";
import Link from "next/link";
import type { Route } from "next";
import { useTranslations } from "next-intl";
import { Button } from "@/components/ui/button";
import { useTemplateRuntime } from "./template-runtime";
export function TemplateNotices() {
  const r = useTemplateRuntime(),
    t = useTranslations("auctionTemplates");
  if (!r.ready || (r.available && !r.record && !r.feedback)) return null;
  return (
    <aside
      data-slot="template-notices"
      data-debug-source="src/components/auctions/template-notices.tsx"
      className="m-4 min-w-0 space-y-3 text-sm [overflow-wrap:anywhere]"
      aria-live="polite"
    >
      {!r.available ? (
        <>
          <p>{t("storage")}</p>
          <Button variant="outline" onClick={r.restore}>
            {t("retry")}
          </Button>
        </>
      ) : null}
      {r.record ? (
        <div className="flex flex-wrap items-center gap-3">
          <p>{t("unknown")}</p>
          <Button
            variant="outline"
            disabled={r.pending || r.denied}
            onClick={() => void r.lookup()}
          >
            {t("lookup")}
          </Button>
        </div>
      ) : null}
      {r.feedback ? (
        <p role={r.feedback === "success" ? "status" : "alert"}>
          {t(r.feedback)}
        </p>
      ) : null}
      {r.completedId ? (
        <Button asChild variant="outline">
          <Link href={`/auction-templates/${r.completedId}` as Route}>
            {t("openSaved")}
          </Link>
        </Button>
      ) : null}
    </aside>
  );
}
